import React, { useEffect, useState } from 'react';

function isIos() {
  return /iphone|ipad|ipod/i.test(window.navigator.userAgent);
}

function isInStandaloneMode() {
  return window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone;
}

function isMobileDevice() {
  return window.matchMedia('(max-width: 900px)').matches;
}

function InstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showIosHint, setShowIosHint] = useState(false);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    if (!isMobileDevice() || isInStandaloneMode()) return;

    if (isIos()) {
      setShowIosHint(true);
      return;
    }

    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };

    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  if (hidden || isInStandaloneMode() || !isMobileDevice()) return null;

  const onInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    await deferredPrompt.userChoice;
    setDeferredPrompt(null);
    setHidden(true);
  };

  return (
    <div className="install-prompt" role="region" aria-label="Install app">
      <div className="install-prompt-inner">
        <div className="install-prompt-text">
          <strong>Install Emerald Horizon</strong>
          <span>Quick access from your home screen.</span>
        </div>
        {showIosHint ? (
          <div className="install-prompt-actions">
            <button
              type="button"
              className="install-prompt-btn"
              onClick={() => setHidden(true)}
            >
              Got it
            </button>
            <span className="install-prompt-ios">
              Tap <strong>Share</strong> → <strong>Add to Home Screen</strong>
            </span>
            <button
              type="button"
              className="install-prompt-dismiss"
              onClick={() => setHidden(true)}
              aria-label="Dismiss install prompt"
            >
              ✕
            </button>
          </div>
        ) : (
          <div className="install-prompt-actions">
            <button
              type="button"
              className="install-prompt-btn"
              onClick={onInstall}
              disabled={!deferredPrompt}
            >
              Install App
            </button>
            <button
              type="button"
              className="install-prompt-dismiss"
              onClick={() => setHidden(true)}
              aria-label="Dismiss install prompt"
            >
              ✕
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default InstallPrompt;
